export function isProbablyMobile(): boolean {
  if (typeof window === 'undefined') return false;
  const coarse = window.matchMedia('(pointer: coarse)').matches;
  const narrow = window.matchMedia('(max-width: 768px)').matches;
  const uaMobile = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
  return coarse && (narrow || uaMobile);
}

export function isOperatorMobileLock(user: { role?: string; requiresAttendance?: boolean } | null | undefined): boolean {
  return isProbablyMobile() && user?.role === 'OPERATOR' && user?.requiresAttendance !== false;
}

export const OPERATOR_MOBILE_ALLOWED_PREFIXES = ['/timbra', '/timbratura/me'];

export function isOperatorMobileAllowedPath(pathname: string): boolean {
  if (pathname === '/timbratura/me') return true;
  if (pathname.startsWith('/timbra')) return true;
  return false;
}
